module.exports = __webpack_public_path__ + "images/landing_mgp_guitar.f00ce2b9fa359dae523b73a6bdfb8adf.jpg";